import { C_BUTTON__collection_create } from '../buttons/C_BUTTON__collection_create';
import { C_BUTTON__collection_hide_unused } from '../buttons/C_BUTTON__collection_hide_unused';

export function C_BAR__collections_actions() {
  return (
    <div className="flex flex-row items-center justify-evenly px-4 w-full h-6 bg-bar ">
      <C_BUTTON__collection_create />
      <C_BUTTON__collection_hide_unused />
    </div>
  );
}
